import Api from '@/api/index';

const VrtTransaction = {
  namespaced: true,
  state: {
    allVrtTransactions: [],
    statusByTitle:{}
  },
  getters: {
    
  },

  mutations: {
    setAllVrtTransactions(state, transactions) {
      state.allVrtTransactions = [...transactions]
      
    }

    // this.status_missed_id = state.allVrtTransactions.find(s=>s.title == 'Missed').id
    // this.status_bacon_id = state.allVrtTransactions.find(s=>s.title == 'Bacon').id
  },

  actions: {
    index(context, filters) {
      return Api.VrtTransaction.index(filters).then(r => r.data).then(r => {
        context.commit('setAllVrtTransactions', r.data)
        return true
      }).catch(err => {
        console.log(err)
        throw Error(err)
      })
    }
  }

};

export default VrtTransaction;
